(function () {
  'use strict';

  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }

  function seededRandom(seed) {
    var s = seed >>> 0;
    return function () {
      s = (s * 1664525 + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }

  function pickCount(block) {
    var min = parseInt(block.dataset.min, 10) || 5;
    var max = parseInt(block.dataset.max, 10) || 20;
    if (max < min) { var t = max; max = min; min = t; }

    var productId = block.dataset.productId || '0';
    // Bucket per ~3 minutes so the number drifts but stays stable on reload.
    var bucket = Math.floor(Date.now() / (1000 * 60 * 3));
    var rand = seededRandom(hash(productId + ':' + bucket));
    return Math.floor(rand() * (max - min + 1)) + min;
  }

  function render(block) {
    var out = block.querySelector('[data-viewers-output]');
    if (!out) return;
    var tpl = block.dataset.template || '[[count]] kişi şu an bu ürünü inceliyor';
    var count = pickCount(block);
    // Liquid pre-converts {count} -> [[count]] to avoid syntax issues in templates.
    out.innerHTML = tpl
      .replace('[[count]]', '<strong>' + count + '</strong>')
      .replace('{count}', '<strong>' + count + '</strong>');
  }

  function init() {
    var blocks = document.querySelectorAll('[data-viewers-block]');
    blocks.forEach(function (block) {
      render(block);
      // Hafif salınım: 25-55 sn arası bir değişim daha
      var next = 25000 + Math.floor(Math.random() * 30000);
      setInterval(function () { render(block); }, next);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
